import React, { useState, useEffect, useRef } from 'react'
import { toCurrency } from '../utils/Convert'
import PaymentTypeLoadPicker from '../paymenttype/PaymentTypeLoadPicker'
import DatePicker from 'react-datepicker'
import { api } from '../utils/Api'
import axios from 'axios'

const PaymentInvoice = ({invc, pcb}) => {
    const [pagos, setPagos] = useState([])
    const [totalPayments, setTotalPayments] = useState(0)    
    const [payDate, setPayDate] = useState(new Date())
    const [update, setUpdate] = useState(false)
    const [invoiceTotal, setInvoiceTotal] = useState(0)
    const [balance, setBalance] = useState(0)
    const [invoice, setInvoice] = useState(null)
    const [payments, setPayments] = useState([])
    const [deposit, setDeposit] = useState(0)
    const [deliveryFee, setDeliveryFee] = useState(0)
    const [fuelRate, setFuelRate] = useState(25)
    const [quantity, setQuantity] = useState(0)  
    const [unitPrice, setUnitPrice] = useState(0)
    const [taxAmount, setTaxAmount] = useState(0)
    const [jobId, setJobId] = useState(0)
    const [otherCharges, setOtherCharges] = useState(0)
    const [trips, setTrips] = useState(0)
    const tax = 0.0825

    const cardCommission = 0.04    
    const factura = useRef()

    useEffect(() => {
        getInvoiceData()
    }, [update])

    const initialState = {
        amount: 0,
        at: payDate,
        type: '',
        comments: '',
        reference: ''
    }

    const [formData, setFormData] = useState(initialState)

    const {
        amount,
        at, 
        comments,
        type,
        reference
    } = formData

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

    const getInvoiceData = async () => {
        const url = api + '/invoice/' + invc
        console.log(url)
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
        try {
            const {data} = await axios.get(url)
            console.log(data)
            console.log(`saldo desde invoice: ${data.balance}`)
            factura.current = data
            console.log(`saldo: ${balance}`)
            setInvoice(data)            
            setPayments(data.payments)            
            setDeposit(data.deposit)
            setInvoiceTotal(data.invoiceTotal) 
            setOtherCharges(data.otherCharges)  
            setDeliveryFee(data.deliveryFee)    
            setTaxAmount(data.taxAmount)       

            if (typeof data.balance === 'undefined') {
                console.log('sin balance aun')
                setBalance(data.invoiceTotal)
            } else {
                console.log('aqui')
                setBalance(data.balance)
            }

            console.log(`saldo: ${balance}`)

            // getJobData(data.job._id)
            setJobId(data.job._id)
            // suma de pagos
            let sumPagos = 0
            sumPagos = data.payments.reduce((acc, pago) => acc + parseFloat(pago.amount), 0)
            setTotalPayments(sumPagos)

            const saldo = data.invoiceTotal - sumPagos + fuelRate - deposit            
            console.log(`suma de pagos: ${sumPagos}, saldo: ${balance}, total factura: ${data.invoiceTotal}, fuelRate: ${fuelRate}, deposit: ${deposit}, saldo: ${saldo}`)
        } catch (err) {
            console.error(err)
            return null
        }
    }

    const updateInvoice = async (factura) => {
        const url = api + '/invoice/' + invc
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }        
        console.log(factura)
        
        try {
            const {data} = await axios.patch(url, factura)
            console.log(data)
            setUpdate(!update)
            updateJob()
        } catch (err) {
            console.error(err)
            return null
        }
    }

    const updateJob = async () => {
        const url = api + '/job/' + jobId        
        const percent = balance/invoiceTotal
        const payload = {
            hasInvoice: true,
            pendingBalance: balance
        }

        if (percent > .75) {
            payload.hold = false
        }

        console.log(payload)

        try {
            await axios.patch(url, payload)
        } catch (err) {
            return null
        }
    }

    const onChangePaymentType = selectedOption => {
        if (selectedOption) {
            setFormData({...formData, type: selectedOption.label})
        }
    }

    const deletePayment = id => {
        const elem = payments[id]
        console.log(elem)
        const pagos = payments.filter(pago => pago._id !== elem._id)
        setTotalPayments(totalPayments - parseFloat(elem.amount) )        
        setBalance(balance + parseFloat(elem.amount))

        const formData = {
            payments: pagos,
            balance: balance + parseFloat(elem.amount)
            // deposit,
            // fuelRate,   
            // invoiceTotal         
        }
        updateInvoice(formData)
        setUpdate(!update)
    }

    const otros = (type, value) => {
        console.log(`tipo: ${type}, valor: ${value}`)
        console.log(factura.current)
        let material = 0
        let surcharge = 0
        let subtotal = 0
        let taxAmount = 0
        let invoiceTotal = 0
        const valor = parseFloat(value)
        switch (type) {
            case 'deliveryFee':                 
                material = factura.current.amount
                surcharge = factura.current.fuelRate * trips
                const otros = factura.current.otherCharges || 0
                subtotal = material + otros + surcharge + valor
                taxAmount = subtotal * tax 
                invoiceTotal = subtotal + taxAmount
                const saldo = invoiceTotal - totalPayments
                setTaxAmount(taxAmount)
                setInvoiceTotal(invoiceTotal)
                setBalance(saldo)
                setDeliveryFee(valor)
                console.log(`yardas: ${quantity}, material: ${material}, otherchrg: ${otros} trips: ${trips}, precio:${unitPrice} tax: ${tax}, surcharge: ${surcharge} subtotal: ${subtotal}, impuestos: ${taxAmount}, total= ${invoiceTotal} balance: ${balance}`)
                break
            case 'otherCharges':                
                material = factura.current.amount
                const viajes = Math.ceil(factura.current.quantity)
                surcharge = factura.current.fuelRate * viajes
                console.log(surcharge)
                subtotal = material + valor + surcharge + deliveryFee - deposit
                taxAmount = subtotal * tax 
                invoiceTotal = subtotal + taxAmount
                console.log(`yardas: ${quantity}, material: ${material}, trips: ${trips} precio:${unitPrice} tax: ${tax}, subtotal: ${subtotal}, impuestos: ${taxAmount}, total= ${invoiceTotal} balance: ${balance}`)
                setBalance(balance + valor)
                setOtherCharges(valor)
                setTaxAmount(taxAmount)
                setInvoiceTotal(invoiceTotal)
                break
            case 'fuel':
                setFuelRate(valor)
                material = quantity * unitPrice 
                surcharge = valor * trips 
                subtotal = material + otherCharges + surcharge + deliveryFee - deposit
                taxAmount = subtotal * tax
                invoiceTotal = subtotal + taxAmount
                console.log(`yardas: ${quantity}, material: ${material}, trips: ${trips} precio:${unitPrice} tax: ${tax}, subtotal: ${subtotal}, impuestos: ${taxAmount}, total= ${invoiceTotal} balance: ${balance}`)
                setTaxAmount(taxAmount)
                setInvoiceTotal(invoiceTotal)
                break            
            default: //( deposit )
                material = factura.current.amount                
                invoiceTotal = factura.current.invoiceTotal
                const nuevo = invoiceTotal - totalPayments - valor
                console.log(`yardas: ${quantity}, material: ${material}, trips: ${trips} precio:${unitPrice} tax: ${tax}, subtotal: ${subtotal}, impuestos: ${taxAmount}, total= ${invoiceTotal} balance: ${balance} nuevo:${nuevo}`)
                console.log(`other charges: ${otherCharges}, delivery fee: ${deliveryFee}`)
                setDeposit(valor)
                setBalance(nuevo)                 
        }
    }

    const DrawList = () => {
        if (payments.length > 0) {
            return payments.map((pago, i) => {
                return <tr key={pago._id}>
                    <td>{new Date(pago.at).toLocaleDateString()} </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>{toCurrency(pago.amount,2)}</td>
                    <td>{pago.type} </td>
                    <td> {pago.reference || 'NA'} </td>
                    <td> {pago.comments || 'NA'} </td>
                    <td><button className='btn btn-danger' onClick={() => deletePayment(i)}>-</button></td>
                </tr>
            })
        } else {
            return <tr>
                <td>No Payments Yet</td>
            </tr>
        }         
    }

    const PaymentTable = () => (
        <div> 
            Material: <strong>{invoice ? toCurrency(invoice.amount,2) : '$0' }</strong><br/>
            + Tax: <strong>{invoice ? toCurrency(taxAmount,2) : '$0' }</strong><br/>
            = Invoice Total: <strong>{toCurrency(invoiceTotal,2)}</strong><br/>
            - Payments: <strong>{toCurrency(totalPayments,2)}</strong> <br/>
            = Balance: <strong>{toCurrency(balance,2)} </strong><br/>
            <div className='form-group row'>
                <div className='col-sm-2'>
                    <label className='text-muted'>Deposit</label>
                    <input
                        type='number'
                        step='0.1'
                        min='0'
                        name='deposit'
                        className='form-control'
                        defaultValue={deposit} 
                        // onBlur={(e) => setDeposit(e.target.value)} 
                        onBlur={(e) => otros('deposit', e.target.value)}   
                    />
                </div>   
                <div className='col-sm-2'>
                    <label className='text-muted'>Delivery Fee</label>
                    <input
                        // onBlur={(e) => setDeliveryFee(e.target.value)}
                        onBlur={(e) => otros('deliveryFee', e.target.value)}
                        type='number'
                        step='0.1'
                        name='deliveryFee'
                        className='form-control'
                        defaultValue={deliveryFee}   
                    />
                </div>   
                <div className='col-sm-3'>
                    <label className='text-muted'>Fuel Surcharge</label>
                    <input 
                        // onBlur={(e) => setFuelRate(e.target.value)}
                        onBlur={(e) => otros('fuel', e.target.value)}
                        type='number'
                        name='fuelRate'
                        className='form-control'
                        defaultValue={fuelRate}
                    />
                </div>    
                <div className='col-sm-3'>
                    <label className='text-muted'>Other Charges</label>
                    <input
                        type='number'
                        onBlur={(e) => otros('otherCharges', e.target.value)}
                        name='otherCharges'
                        className='form-control'
                        defaultValue={otherCharges}
                    />
                </div>  
            </div>
            <table className='table'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Type</th>
                        <th>Reference</th>
                        <th>Comments</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                   <DrawList />
                </tbody>
            </table>
        </div>
    )

    const addPayment = () => {
        let pago = amount
        if (type === 'Credit Card') {
            pago = amount * (1 + cardCommission)
        }

        const nuevo = {
            amount: pago,
            reference,
            comments,
            type,
            at: payDate           
        }
        const viejo = payments
        payments.push(nuevo)
        setPagos(nuevo)
        
        const nuevaSuma = totalPayments + parseFloat(amount)
        const saldo = invoice.invoiceTotal - nuevaSuma + fuelRate - deposit
        console.log(`saldo: ${saldo}`)
        setBalance(saldo)
        setTotalPayments(nuevaSuma)      
        console.log(`otros cargos: ${otherCharges}`)  
        // setPagos(oldArray => [...oldArray, nuevo])
        const formData = {
            payments: viejo,        
            balance: saldo,
            fuelRate,
            deposit,   
            otherCharges 
        }
        updateInvoice(formData)
    }

    const saveChanges = () => {
        console.log('update invoice')
        const cambios = {
            otherCharges,
            deliveryFee,
            fuelRate,
            deposit,
            balance,
            invoiceStatus: 'partial'
        }
        console.log(cambios)
        updateInvoice(cambios)
        pcb(balance)
    }

    return (
        <div>            
            { payments && <PaymentTable /> }
            <div className='form-group row'>
                <div className='col-sm-3'>
                    <input 
                        type='number' 
                        step='0.1'
                        name='amount'
                        placeholder='Amount'
                        onChange={onChange}
                        required
                    />        
                </div>   
                <div className='col-sm-3'>
                    <DatePicker 
                        selected={payDate}                
                        onChange={(date) => setPayDate(date)}                                                
                    />
                </div>
                <div className='col-sm-3'>
                    <PaymentTypeLoadPicker action={onChangePaymentType} />
                </div>
                <div className='col-sm-3'>
                    {
                        type !== 'Cash' &&
                        <input
                            type='text'
                            name='reference'
                            placeholder='Reference'
                            amount={reference}
                            onChange={onChange}
                        />
                    }                    
                </div>                     
                <div className='col-sm-3'>
                    <input
                        type='text'
                        name='comments'
                        placeholder='Comments'
                        onChange={onChange}
                    />
                </div>
                <div className='col-sm-3'>
                    <button onClick={addPayment} className="btn btn-success">+</button>
                </div>                
            </div>   
            <button className='btn btn-primary' onClick={saveChanges} >Save</button>                               
        </div>
    )
}

export default PaymentInvoice